import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Product } from '@shared/models/product.model';
import { ProductDetailViewModel } from '../../../../../product-detail/models/product-detail-view-model';
import { EllipsisClickData } from '../../../../../shared/models/usf-product-card.model';
import { UsfProductCardModeEnum } from '../../../../../shared/constants/usf-product-card-mode.enum';
import { ItemTypes } from '@app/lists/shared/list-detail-management/model/list-detail-management-view.model';
import { ListState, MasterListState } from '@usf/ngrx-list';
import { HandPricingProductDetails } from '@app/order/models/order-view-model';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-ingredient-detail-header',
  templateUrl: './ingredient-detail-header.component.html',
  styleUrls: ['./ingredient-detail-header.component.scss'],
})
export class IngredientDetailHeaderComponent {
  @Input() product: Product;
  @Input() isOnline: boolean;
  @Input() pricingDisabled = false;
  @Input() platform: PlatformEnum;

  @Output() ellipsisEvent = new EventEmitter<EllipsisClickData>();
  @Output() productEvent = new EventEmitter<number>();

  platformRef = PlatformEnum;

  constructor() {}

  onProductClick = () => {
    this.productEvent.emit(this.product.productNumber);
  };

  ellipsisClick($event: Event) {
    this.ellipsisEvent.emit({
      event: $event,
      isTouch: false,
      product: this.product,
      mode: UsfProductCardModeEnum.menuProfitPro,
      itemType: ItemTypes.product,
      list: undefined,
      pricingDisabled: this.pricingDisabled,
      isSelected: false,
    });
  }

  transformProductToProductDetail() {
    return {
      ...this.product,
    } as ProductDetailViewModel;
  }
}
